import React from 'react';
import Toastr from './toaster'; // Assuming Toastr is a class component

class ToastrService {
  constructor() {
    this.toastrRef = React.createRef();
  }

  success(message) {
    if (this.toastrRef.current) {
      const toaster = { message: message, type: 'success' };
      this.toastrRef.current.triggerToastButtonClick(toaster);
    }
  }

  error(message) {
    if (this.toastrRef.current) {
      const toaster = { message: message, type: 'error' };
      this.toastrRef.current.triggerToastButtonClick(toaster);
    }
  }

  info(message) {
    if (this.toastrRef.current) {
      const toaster = { message: message, type: 'info' };
      this.toastrRef.current.triggerToastButtonClick(toaster);
    }
  }

  warning(message) {
    if (this.toastrRef.current) {
      const toaster = { message: message, type: 'warning' };
      this.toastrRef.current.triggerToastButtonClick(toaster);
    }
  }

  setToastrRef(ref) {
    this.toastrRef = ref;
  }

  getToastrComponent() {
    return <Toastr ref={this.toastrRef} />;
  }
}

export default new ToastrService();
